module.exports = __webpack_public_path__ + "img/astrapay.84bb6639.webp";